import { Link, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/lib/auth';
import { cn } from '@/lib/utils';
import { getVisibleSettingsNavItems } from '@/components/settings/settings-navigation.config';

export function SettingsTabs() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { user } = useAuth({ middleware: 'auth', tmp: 'SettingsTabs' });
  const visibleLinks = getVisibleSettingsNavItems(user);

  const isActive = (to: string) => pathname.startsWith(to);

  return (
    <nav className="mb-6 border-b border-border-subtle" aria-label={t('settings.tabsNavLabel')}>
      <ul className="-mb-px flex flex-wrap gap-1">
        {visibleLinks.map(({ to, labelKey }) => (
          <li key={to}>
            <Link
              to={to}
              className={cn(
                'inline-block rounded-t-md border-b-2 px-3 py-3 font-label transition-colors',
                isActive(to)
                  ? 'border-brand-secondary text-brand-secondary'
                  : 'border-transparent text-muted-foreground hover:text-foreground',
              )}
            >
              {t(labelKey)}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
